/**
 *  @class
 *  @function PredictiveSearch
 */


class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.form = this.container.querySelector('.search-drawer--searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResultsWrapper = this.container.querySelector('.search-drawer--inner');
    this.predictiveSearchResults = this.predictiveSearchResultsWrapper.querySelector('.thb-predictive-search');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        console.log('eeeeeeeee')
        event.preventDefault();
        document.body.classList.toggle('open-search');
        document.body.classList.toggle('open-cc');
        if (document.body.classList.contains('open-search')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }
  
 // $('.sku_search').change(function() {
 //    console.log( 'searchTerm')
 //    // this.getSearchResults(searchTerm); 
 //  });
  
  getQuery() {
    return this.input.value.trim();
  }
onChange() {
  const searchTerm = this.getQuery();
  const viewAllBtn = document.getElementById('view_all_btn');
  if (searchTerm !== '') {
    viewAllBtn.setAttribute('colorData', searchTerm);
    setTimeout(function() {
      viewAllBtn.style.display = "flex";
    }, 2000);

    // Use fetch instead of the GraphQL API call
    fetch(`/search?q=${searchTerm}&filter.v.availability=1`, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProductList = doc.querySelector('#product-grid'); // Extract the <ul> element with id="product-grid"

      if (newProductList) {
          $('#search-results').empty();
        // Append the entire <ul id="product-grid"> element itself (not just innerHTML)
        $('#search-results').append(newProductList);

        // Check if more than 4 products are present to display "See More" button
        if (newProductList.children.length > 4 && document.getElementById("view_all_btn")) {
          document.getElementById("view_all_btn").style.display = "block";
        }
      } else {
        $('#search-results').html('<div class="no-products-found">Product not found</div>');
      }
    })
    .catch((error) => {
      console.error('Error fetching products:', error);
      $('#search-results').html('<p>Error fetching products. Please try again later.</p>');
    });

  } else {
    // Handle case where searchTerm is empty or invalid
    setTimeout(function() {
      if (document.getElementById("view_all_btn")) {
        document.getElementById("view_all_btn").style.display = "none";
      }
    }, 2000);
    $('#search-results').empty();
    this.container.classList.remove('active');
  }

  // Ensure container class is set based on searchTerm presence
  if (searchTerm.length) {
    this.container.classList.add('active');
    // this.getSearchResults(searchTerm); // Assuming this function handles further search results
  }
}

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    // this.getSearchResults(searchTerm);
  }
 


  // getSearchResults(searchTerm) {
  //   const queryKey = searchTerm.replace(" ", "-").toLowerCase();

  //   this.predictiveSearchResults.classList.add('loading');

  //   fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,collection,article,query&${encodeURIComponent('resources[limit]')}=6&section_id=predictive-search`)
  //     .then((response) => {
  //       this.predictiveSearchResults.classList.remove('loading');
  //       if (!response.ok) {
  //         var error = new Error(response.status);
  //         throw error;
  //       }

  //       return response.text();
  //     })
  //     .then((text) => {
  //       const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

  //       this.renderSearchResults(resultsMarkup);
  //     })
  //     .catch((error) => {
  //       throw error;
  //     });
  // }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');

    if (document.body.classList.contains('animations-true')) {
      gsap.to(this.predictiveSearchResults.querySelectorAll('.product-card .product-featured-image-link'), { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
    }
    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});